import { CopyText } from '@acorn-portal/shared/src/components/text';
import {
	DescriptionSectionWording,
	ImportantSectionWording,
	ProceedSectionWording,
	NextStepsSectionWording,
} from './MissedPaymentFormGen';
import { isYoungDriver } from '@acorn-portal/shared/src/utils/is-young-driver';
import { SchemeType } from '@acorn-portal/shared/src/services/interface/Shared';

export interface PaymentPlanSections {
	description: {
		[key: number]: string;
	};
	descriptionV2: {
		[key: number]: string;
	};
	important: {
		[key: number]: string;
	};
	importantV2: {
		[key: number]: string;
	};
	proceed: {
		[key: number]: string;
	};
	proceedV2: {
		[key: number]: string;
	};
	next: {
		[key: number]: string;
	};
	nextV2: {
		[key: number]: string;
	};
	nextV2PayInFull: {
		[key: number]: string;
	};
}
interface ISection {
	scheme?: SchemeType;
	paymentPlanVersion: number;
	payInFull?: boolean;
}

export const DescriptionSection = ({ scheme, paymentPlanVersion }: ISection) => {
	const Section = DescriptionSectionWording(paymentPlanVersion, isYoungDriver(scheme));
	return Section;
};

export const ImportantSection = ({ scheme, paymentPlanVersion }: ISection) => {
	const Section = ImportantSectionWording(paymentPlanVersion, isYoungDriver(scheme));
	if (paymentPlanVersion === 2) {
		return null;
	}
	return (
		<>
			<CopyText>
				<strong>Important:</strong>
			</CopyText>
			{Section}
		</>
	);
};

export const ProceedSection = ({ scheme, paymentPlanVersion }: ISection) => {
	const Section = ProceedSectionWording(paymentPlanVersion, isYoungDriver(scheme));
	return Section;
};

export const NextStepsSection = ({ scheme, paymentPlanVersion, payInFull = false }: ISection) => {
	const Section = NextStepsSectionWording(paymentPlanVersion, isYoungDriver(scheme), payInFull);
	return (
		<>
			<CopyText>
				<strong>What happens next?</strong>
			</CopyText>
			{Section}
		</>
	);
};
